import styled, { css } from 'styled-components';

import type { ListingFiltersVariant } from '../../types';

export const FiltersClearButton = styled.button<{
  variant: ListingFiltersVariant;
}>`
  display: flex;
  background-color: transparent;
  white-space: nowrap;
  place-content: center;
  align-items: center;

  ${({ theme, variant }) => css`
    padding: ${theme.spacing(1)};
    color: ${variant === 'default' ? 'initial' : theme.colors.white};
    font-size: ${theme.fontSizes.p3};
  `}
`;
